import axios from "axios";
import { toast } from "react-toastify";
import { loginRoute as appLoginRoute } from "../routes/reactRoutes";

const axiosInstance = axios.create({
  headers: { "ngrok-skip-browser-warning": "69420" },
});

// Request Interceptor - Automatically add token to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor - Handle errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const statusCode = error.response?.status;
    const responseData = error.response?.data;

    // Handle session expiry globally
    if (
      statusCode === 401 &&
      (responseData?.message === "Unauthorized" || responseData?.message === "You are not authorized to access this resource")
    ) {
      // Show toast notification
      toast.dismiss();
      toast.error("Session expired. Please login again.", {
        autoClose: false,
      });

      // Clear local storage
      localStorage.removeItem("token");
      localStorage.removeItem("avatar");
      
      // Redirect to login
      setTimeout(() => {
        window.location.href = appLoginRoute;
      }, 500); // Small delay to ensure toast renders
      
      return Promise.reject(error);
    }

    // Handle network errors
    if (error.message === "Network Error") {
      toast.dismiss();
      toast.error(
        "Unable to reach the server. Please try again later.",
        {
          autoClose: false,
        }
      );
      return Promise.reject(error);
    }

    // Handle server errors
    if (statusCode === 500) {
      toast.dismiss();
      toast.error("Something went wrong. Please try again later.", {
        autoClose: false,
      });
      return Promise.reject(error);
    }

    // For other errors, let components handle them if needed
    return Promise.reject(error);
  }
);

export default axiosInstance;